var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<div class=\"container\"><div class=\"row\"><div class=\"col-sm-4\"><dashboard-sales-comparison></dashboard-sales-comparison></div><div class=\"col-sm-4\"><dashboard-top-vendors date=\"Last30\"></dashboard-top-vendors></div><div class=\"col-sm-4\"><dashboard-source-breakdown date=\"Last30\"></dashboard-source-breakdown></div></div><div class=\"row\"><dashboard-source-comparison date=\"Last30\"></dashboard-source-comparison></div></div>";
var id1="dashboard-rep.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;